import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSuite = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M10.142 4.441a.5.5 0 0 1 .471-.332h2.774a.5.5 0 0 1 .471.332l1.34 3.75a.5.5 0 0 1-.472.668H9.274a.5.5 0 0 1-.47-.668l1.338-3.75Zm5.428.337a.5.5 0 0 1 .472-.669h1.721a.5.5 0 0 1 .387.184l3.068 3.75a.5.5 0 0 1-.387.816h-3.45a.5.5 0 0 1-.47-.331l-1.34-3.75Zm5.61 6.403a.5.5 0 0 0-.383-.822h-3.396a.5.5 0 0 0-.474.342l-2.649 7.947c-.087.261.251.45.429.24l6.473-7.707Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M2.82 11.181a.5.5 0 0 1 .382-.822h3.396a.5.5 0 0 1 .475.342l2.648 7.947c.088.261-.25.45-.428.24L2.819 11.18Zm9.653 8.134a.5.5 0 0 1-.948 0l-2.766-8.298a.5.5 0 0 1 .474-.658h5.532a.5.5 0 0 1 .474.659l-2.766 8.297Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M3.168 8.86a.5.5 0 0 1-.387-.817l3.069-3.75a.5.5 0 0 1 .387-.184h1.721a.5.5 0 0 1 .47.669L7.09 8.528a.5.5 0 0 1-.471.331h-3.45Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcSuite");

export { IcSuite };
//# sourceMappingURL=ic-suite.js.map
